import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { IWGSharedService } from '../shared/services/shared.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(
        private router: Router,
        private dialogRef: MatDialog,
        private sharedService: IWGSharedService
    ) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        var tokenKey = 'accessToken';
        if (this.sharedService.getIsEmbed()) {
            tokenKey = 'accessTokenCxp';
            this.sharedService.setCookie("IsEmbed", '1', +10);  
        } else {
               this.sharedService.setCookie("IsEmbed", '0', +10);   
        }       
        const token: string = localStorage.getItem(tokenKey);
        if (token) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }

        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                     
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {   
              
                var isEmbed = this.sharedService.getIsEmbed();
                if (isEmbed === true) {
                    if (error && (error.status == 401 || error.status == 404 || error.status == undefined)) {
                        this.dialogRef.closeAll();
                        localStorage.removeItem("accessTokenCxp");                    
                        var path = localStorage.getItem('NavigatePath');                      
                        this.router.navigate([path]);
                    }
                } else {
                    if (error && (error.status == 401 || error.status == undefined)) {
                        this.dialogRef.closeAll();
                        this.router.navigate(['login']);
                    }
                }                
                return throwError(error);
            }));
    }
}